import { OperatingManagerDetails } from "Components/Pages/RewardsSetup/OperatingManagerDetails/OperatingManagerDetails";
import { OperatingManagerPermissions } from "Components/Pages/RewardsSetup/OperatingManagerPermissions/OperatingManagerPermissions";
import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { OperatingManagerFormFields } from "Shared/types/OperatingManager";
import { CreateManagerState } from "../CreateManagerStepper";

export const useInformationAndPermissionsStep = ({
  formFields,
  existingEmployerId,
}: CreateManagerState
) => {
  const formMethods = useForm<OperatingManagerFormFields>({
    mode: "onBlur",
  });
  const { register, getValues, trigger } = formMethods;

  useEffect(() => {
    register({ name: "locations" });
  }, [register]);

  const onComplete = async () => {
    const values = getValues();
    const isValid = await trigger();
    if (isValid) {
      return {
        formFields: values,
      };
    }
    return false;
  };

  const stepContent = (
    <FormProvider {...formMethods}>
      <OperatingManagerDetails
        formFields={formFields}
        shouldDisableFields={!!existingEmployerId}
      />
      <OperatingManagerPermissions
        formFields={formFields}
        shouldDisableAdminFields={!!existingEmployerId}
      />
    </FormProvider>
  );

  return {
    label: "Information & Permissions",
    content: stepContent,
    onComplete,
  };
};
